export default __webpack_public_path__ + "static/media/logout.b9a1e5a7.svg";